import { colors, TableCell, TableRow, Tooltip, typography } from '@insurancemenu/imenu-components-lib';
import { TABLE_CELL_HOVER_BG_COLOR } from '@insurancemenu/imenu-components-lib/dist/components/tables/utils/constants';
import styled, { css, CSSProp } from 'styled-components';
import InCellDivisionBlock from 'components/common/general/InCellDivisionBlock';

const ROW_HEIGHT_REM = 2.3994;
const EMAILS_ROWS_GAP_REM = 0.8;

export const TableRowStyled = styled(TableRow)<{ $isSelected: boolean }>`
  box-sizing: border-box;
  transition: none;
  border-style: solid;
  border-width: 0.2rem 0.2rem 0.1rem 1rem;
  border-color: transparent transparent ${colors.neutral[300]} transparent;
  background-color: ${({ $isSelected }): CSSProp => $isSelected && TABLE_CELL_HOVER_BG_COLOR};

  ${({ $isSelected }): CSSProp =>
    $isSelected &&
    css`
      border-color: ${colors.blue[600]};

      /* Visually makes the bottom border 0.2rem without changing row height */
      box-shadow: inset 0 -0.1rem 0 ${colors.blue[600]};
    `}

  /* Keep only one border between adjacent selected rows */
  &[data-selected='true'] + &[data-selected='true'] {
    border-top-color: transparent;
  }

  &:hover {
    background-color: ${TABLE_CELL_HOVER_BG_COLOR};
  }
`;

export const TableCellStyled = styled(TableCell)`
  ${typography.regular[16]}
  color: ${colors.neutral[900]};
  padding: 0;

  &:first-child {
    padding: 1.6rem 1rem 1.6rem 1.6rem;
  }

  &:nth-child(2) {
    padding: 1.6rem 0;
  }

  &:nth-child(3) {
    & > div {
      padding-left: 1rem;
    }
  }
`;

export const InCellDivisionBlockStyled = styled(InCellDivisionBlock)`
  padding-bottom: 1.6rem;
  margin: 0;
  padding-top: 1.6rem;

  &:last-child {
    padding-bottom: 1.6rem;
  }
`;

export const StatusStyled = styled.div`
  height: 2.2rem;
`;

export const StatusesListStyled = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

export const ActionBlockStyled = styled.div`
  height: ${ROW_HEIGHT_REM}rem;
  display: flex;
  align-items: center;
  gap: 3rem;
`;

export const ProductLineCellContentStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const ProductLineLabelStyled = styled.span<{ $isTerminated: boolean }>`
  color: ${({ $isTerminated }): string => ($isTerminated ? colors.red[600] : 'inherit')};
`;

export const ProductLineIconsStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
`;

export const EffectiveDateContentStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const EffectiveDateTextStyled = styled.span`
  min-width: 8rem;
`;

export const TooltipContentStyled = styled.div`
  gap: 1rem;
  display: flex;
  align-items: center;
`;

export const FixedWidthTooltipStyled = styled(Tooltip)`
  width: 30rem;
  white-space: wrap;

  &::before {
    left: 1rem;
  }
`;

export const EmailsTypeLabelStyled = styled.div`
  ${typography.regular[16]}
  color: ${colors.neutral[900]};
  padding: 0;
  min-width: 5.5rem;
`;

export const EmailsByTypeStyled = styled.div`
  display: flex;
  gap: 1rem;
`;

export const RestEmailsCountStyled = styled.span`
  ${typography.regular[14]}
  color: ${colors.neutral[700]};
`;

// Total height includes all rows plus the gaps between them, so N rows have N - 1 gaps
export const EmailsCellContentStyled = styled.div<{ $rowsCount: number }>`
  min-height: ${({ $rowsCount }): CSSProp =>
    `${$rowsCount * ROW_HEIGHT_REM + ($rowsCount - 1) * EMAILS_ROWS_GAP_REM}rem`};
  display: flex;
  flex-direction: column;
  gap: ${EMAILS_ROWS_GAP_REM}rem;
`;
